import * as React from 'react';

export interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const Container: React.FC<ContainerProps> = ({
  children,
  className = '',
}) => {
  return (
    <div className={`mx-auto max-w-container px-5 md:px-16 grid grid-cols-6 md:grid-cols-12 gap-x-4 md:gap-x-6 ${className}`.trim()}>
      {children}
    </div>
  );
};
